import React from "react";
import { FieldAttributes, useField, useFormikContext } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useStyles } from "./UpdateDatePicker.style";
import { useTranslation } from "react-i18next";
import moment, { Moment } from "moment";
import "moment/locale/de";
import "moment/locale/es";

type UploadDatePickerProps = {
  label: string;
} & FieldAttributes<{}>;

export const UploadDatePicker: React.FC<UploadDatePickerProps> = (props) => {
  const [field, meta] = useField<{}>(props);
  const { setFieldValue } = useFormikContext();
  const { i18n } = useTranslation();
  moment.locale(i18n.language);
  const errorText = meta.error && meta.touched ? meta.error : "";
  const styles = useStyles();

  const handleChange = (date: Moment | null) => {
    setFieldValue(field.name, date ? date.format("YYYYMMDD") : null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language}>
      <DatePicker
        label={props.label}
        className={styles.datepicker}
        slotProps={{ 
          textField: { 
            variant: 'standard', 
            error: !!errorText, 
            helperText: errorText, 
          },
          actionBar: {
            actions: ['clear']
          }
        }}
        value={field.value ? moment(field.value, "YYYYMMDD") : null}
        onChange={handleChange}
        disableFuture
        openTo="year"
        views={["year", "month", "day"]}
      />
    </LocalizationProvider>
  );
};
